export { default } from './AiBatchIntake';
